import React from 'react'
import PropTypes from 'prop-types'
import TabPanel from '@material-ui/core/Tabs'
import TabItem from '@material-ui/core/Tab'
import { useJss } from '../../layout/jss'

function Tab({ value, index, children }) {
  return (
    <div hidden={value !== index}>
      {children}
    </div>
  )
}

Tab.propTypes = {
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
}

function Tabs({
  activeKey, children, onSelect, tabButtons, header,
}) {
  const useStyles = useJss({
    root: {
      minHeight: '75px !important',
    },
  })
  const classes = useStyles()
  return (
    <>
      <TabPanel
        value={activeKey}
        onChange={onSelect}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        className={classes.root}
      >
        {
          tabButtons.map(
            (tab) => (
              <TabItem
                key={tab.label}
                label={tab.label ? tab.label : ''}
                icon={tab.icon ? tab.icon : null}
              />
            ),
          )
        }
      </TabPanel>
      { header }
      { children }
    </>
  )
}

Tabs.propTypes = {
  activeKey: PropTypes.number.isRequired,
  children: PropTypes.arrayOf(
    PropTypes.any,
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  tabButtons: PropTypes.arrayOf(
    PropTypes.shape([PropTypes.node, PropTypes.node]),
  ).isRequired,
  header: PropTypes.objectOf(PropTypes.any),
}

Tabs.defaultProps = {
  header: <div />,
}

Tabs.Content = Tab

export default Tabs
